export default __webpack_public_path__ + "static/media/hero_top_vector.47af88c2.svg";